export default {
    "Mixer": "Mélangeur",
    "Switch to fullscreen": "Passer en plein écran",
    "Back to normal": "Retour à la normale",

    // Layer2 component
    "Graphics": "Graphiques",
    "Add graphic": "Ajouter un graphique",
    "Back": "Retour"
}